import React, {useEffect, useState} from 'react';

// import moment for time formatting
import moment from 'moment';

// import colors + spacing
import { Spacing, Colors } from '_styles';

const FlightStatusBadge = (props) => {

    // states
    const [formattedTime, setFormattedTime] = useState('');
    const [showTimeDifference, setShowTimeDifference] = useState(false);

    // format status time
    useEffect(() => {
        if (props?.statusTime && props?.statusTime.length > 0) {

            // get time in correct format
            const time = moment(new Date(props?.statusTime)).format("HH:mm");

            // check if boarding flight
            if (props?.flight?.includes("/boarding")) {

                // subtract 30 minutes from status time for boarding
                const boardingTime = moment(new Date(new Date(props?.statusTime).getTime() - 30 * 60 * 1000)).format("HH:mm");
                setFormattedTime(boardingTime);

            } else {

                // set formatted time to status time
                setFormattedTime(time);

            }
        }
        if (props?.statusTime && props?.statusTime.length > 0 && props?.originalTime && props?.originalTime.length > 0) {
            // check if the status time and original time are different
            if (moment(new Date(props?.statusTime)).format("HH:mm") !== moment(new Date(props?.originalTime)).format("HH:mm")) {
                setShowTimeDifference(true);
            } else {
                setShowTimeDifference(false);
            }
        }
    }, [props]);

    return (
        <div className='mt-1' style={{ display: 'flex', flex: 1, padding: 0, margin: 0, borderBottomWidth: 0.5, borderBottomColor: 'white', borderBottomStyle: 'solid' }} onClick={(e) => { e.stopPropagation(); props?.openModal(); }}>

            {/* time stamp */}
            <div style={{ display: 'flex', flex: 1.10 }}>

                {/* current time stamp */}
                <div style={{ flex: 1, display: 'flex', justifyContent: 'left', alignItems: 'left' }}>
                    <p style={{ textAlign: 'left', color: 'white', padding: 0, margin: 0 }}>{formattedTime}</p>
                </div>

                {/* original time stamp */}
                <div style={{ flex: 1, display: 'flex', justifyContent: 'left', alignItems: 'left' }}>
                    {showTimeDifference && <p style={{ textDecoration: 'line-through', color: 'white', marginLeft: Spacing.SCALE_8, padding: 0, margin: 0 }}>{moment(new Date(props?.originalTime)).format('HH:mm')}</p>}
                </div>

            </div>

            {/* time stamp badge (on time / delay / early / landed / departed) */}
            <div style={{ flex: 1, alignItems: 'center', display: 'flex', justifyContent: 'flex-end', padding: 0, margin: 0 }} data-tippy-content="Flight Status">
                {props?.operatingStatus && (
                    <p style={{
                        fontSize: 8,
                        fontWeight: '900',
                        textAlign: 'center',
                        padding: Spacing.SCALE_2,
                        margin: 0,
                        border: '1px solid',
                        borderRadius: 2.5,
                        borderColor: props?.operatingStatus == 'On Time' ? Colors.PRM_LIGHT_BLUE : 'white',
                        color: props?.operatingStatus == 'On Time' ? 'darkgreen' : 'white',
                        backgroundColor: props?.operatingStatus == 'Early' ? 'green' : props?.operatingStatus == 'Delay' ? 'red' : props?.operatingStatus == 'On Time' ? 'white' : props?.operatingStatus == 'Cancelled' ? 'red' : 'white'
                    }}>{props?.operatingStatus.toUpperCase()}</p>
                )}
                {props?.flightStatus && (
                    <p style={{ fontSize: 8, textAlign: 'center', padding: Spacing.SCALE_2, margin: 0, border: '1px solid', borderRadius: 2.5, color: 'white', backgroundColor: 'green' }}>{props?.flightStatus.toUpperCase()}</p>
                )}
            </div>
            
        </div>
    );
};

export default FlightStatusBadge;
